export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-vietnamese-500-normal.woff2?da9e7b1a160d0735c4db286182371e70";